<template>
  <span :class="containerClass" class="import-status">
    <span class="import-status__icon-container">
      <icon :name="iconName" />
    </span>
    <span class="import-status__text">
      {{translatedStatus}}{{maybeErrorCount}}
    </span>
  </span>
</template>

<script>
export default {
  name: 'import-status',
  props: {
    value: {
      type: String,
      required: true,
    },
    errors: {
      type: Number,
      required: true,
    },
  },
  computed: {
    translatedStatus() {
      return this.$t(`statuses.${this.value}`);
    },
    maybeErrorCount() {
      if (this.errors === 0) return '';
      return `, ${this.errors} Fehler `;
    },
    isFinished() {
      return this.value === 'FINISHED';
    },
    iconName() {
      switch (this.value) {
        case 'CANCELLED':
        case 'ABORTED':
          return 'close';
        case 'RUNNING':
          return 'clock';
        case 'FINISHED':
          return 'check';
        default:
          return 'list';
      }
    },
    containerClass() {
      return {
        'uk-text-muted': this.value === 'PENDING',
        'uk-text-warning': this.value === 'RUNNING',
        'uk-text-success': this.value === 'FINISHED',
        'uk-text-danger': this.value === 'ABORTED' ||
                          this.value === 'CANCELLED',
      };
    },
  },
  i18n: {
    messages: {
      de: {
        statuses: {
          ABORTED: 'Abgebrochen',
          CANCELLED: 'Storniert',
          PENDING: 'Geplant',
          RUNNING: 'Läuft…',
          FINISHED: 'Abgeschlossen',
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.import-status__icon-container {
  margin-right: 4px;
}
</style>



// WEBPACK FOOTER //
// ImportStatus.vue?dd07dc0e